/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const IbanAttributeR = t.interface({});

// optional attributes
const IbanAttributeO = t.partial({
  attributeDescription: t.string,

  attributeName: t.string,

  objId: t.Integer
});

export const IbanAttribute = t.intersection(
  [IbanAttributeR, IbanAttributeO],
  "IbanAttribute"
);

export type IbanAttribute = t.TypeOf<typeof IbanAttribute>;
